import { SET_USER, REMOVE_USER, SET_USER_READY } from 'actions/userActions';
import * as Sentry from '@sentry/react';
import { addProtocolToUrl } from 'helpers/urlHelpers';
import { loadedUpdateUserProfile } from '../../actions/profileActions';

export const initialState = {
  avatarUrl: null,
  email: null,
  firstName: null,
  lastName: null,
  linkedinUrl: null,
  onboardingCompleted: null,
  ready: false,
};

const rehydrateUserData = (user) => {
  const { websiteUrl, linkedinUrl, twitterUrl, githubUrl, dribbbleUrl, ...otherUserProps } = user;

  return {
    websiteUrl: addProtocolToUrl(websiteUrl),
    linkedinUrl: addProtocolToUrl(linkedinUrl),
    twitterUrl: addProtocolToUrl(twitterUrl),
    githubUrl: addProtocolToUrl(githubUrl),
    dribbbleUrl: addProtocolToUrl(dribbbleUrl),
    ...otherUserProps,
  };
};

function userReducer(state = initialState, { type, payload }) {
  switch (type) {
    case SET_USER: {
      const user = rehydrateUserData(payload);
      Sentry.configureScope((scope) => scope.setUser({ token: user.token, id: user.id }));
      return {
        ...state,
        ...user,
        ready: true,
      };
    }
    case SET_USER_READY:
      return {
        ...state,
        ready: !!payload,
      };
    case REMOVE_USER:
      return { ...initialState, ready: true };
    case loadedUpdateUserProfile().type:
      return {
        ...state,
        ...payload.user,
        ready: true,
      };
    default:
      return state;
  }
}

export default userReducer;
